



































































































































































































































































































import { Component, Vue, Model, Watch, Prop, BasePage } from "@/common";

import { TwTable } from "@/components";

import moment from "moment";

@Component({})
export default class ColumnLayout extends BasePage {
  layoutShow: boolean = false;

  @Model("change") private value: boolean;

  @Watch("value")
  private changeShow(val) {
    this.layoutShow = val;
  }

  @Prop({ default: "" })
  layoutCode: string;

  @Prop({ default: "" })
  layoutName: string;

  @Prop({ default: false })
  isCustom: boolean;

  @Prop() data: object;
  get layoutTable(): TwTable {
    return this.$refs["layoutTable"] as TwTable;
  }

  private onOk() {
    this.$emit("on-ok");
  }

  private close() {
    this.$emit("change", false);
    this.$emit("on-cancel");
  }

  private onOpen() {
    this.actualLayoutName = this.layoutName;
    this.actualLayoutCode = this.layoutCode;
    const params = {
      cModuleCode: this.layoutCode,
      iShow: this.showVisibleOnly ? 1 : 0
    };

    this.$nextTick(() => {
      this.layoutTable.load(params);
      this.loadAppTable();
      if (this.isCustom === true) {
        this.loadColumnModuleCode();
      }
    });
  }

  sortDrag: boolean = true;

  showVisibleOnly: boolean = true;

  showEdit: boolean = false;

  showInitModal: boolean = false;

  showCustomConfig: boolean = false;

  actualLayoutCode: string = "";

  actualLayoutName: string = "";

  initDataStore: Array<any> = [];

  initSelectTable: string = "";

  columnModel = {
    ID: null,
    cModuleCode: null, // 配置ID
    cModuleName: null, // 配置名称
    cField: null, // 字段名称
    cTitle: null, // 列显示标题
    cDataType: null, // 数据类型
    nWidth: 120, // 列宽
    cAlign: null, // 内容对齐方式
    iShow: 1, // 是否显示
    iSum: 0, // 是否汇总
    iSort: 0, // 是否排序
    iFilter: 0, // 是否过滤
    iEdit: 0, // 是否可编辑
    cGroupHeader: null, // 组合表头
    cColumnRender: null, // 列渲染函数,
    cHeaderRender: null, // 表头渲染函数,
    cFormatter: null,
    nOrderID: null, //排序标识
    cChangeFn: null, //修改后触发
    iSpan: 0, //合并行
    cFixed: null, //锁定方向
    nPrecision: 0, //数据精度
    iOptionType: null, //数据源类型
    cOptionSource: null //数据源表达式
  };

  rules = {
    cTitle: [
      {
        required: true,
        type: "string",
        message: "此属性为必输项",
        trigger: "blur"
      }
    ],
    cField: [
      {
        required: true,
        type: "string",
        message: "此属性为必输项",
        trigger: "blur"
      }
    ],
    cDataType: [
      {
        required: true,
        type: "string",
        message: "此属性为必选项",
        trigger: "change"
      }
    ],
    nWidth: [
      {
        required: true,
        type: "number",
        message: "此属性为必输项",
        trigger: "blur"
      }
    ],
    cAlign: [
      {
        required: true,
        type: "string",
        message: "此属性为必选项",
        trigger: "change"
      }
    ]
  };

  layoutColumns = [
    {
      label: "列标题",
      prop: "cTitle",
      width: 180,
      align: "center",
      attrs: {
        type: "string"
      },
      renderHeader: this.renderHeader
    },
    {
      label: "列字段",
      prop: "cField",
      width: 180,
      align: "center",
      attrs: {
        type: "string"
      }
    },
    {
      label: "数据类型",
      prop: "cDataType",
      width: 100,
      align: "center",
      attrs: {
        type: "string"
      }
    },
    {
      label: "列宽",
      prop: "nWidth",
      width: 100,
      align: "center"
    },
    {
      label: "分组表头",
      prop: "cGroupHeader",
      width: 120,
      align: "center"
    },
    {
      label: "操作",
      width: 90,
      align: "center",
      render: this.renderOperation
    }
  ];

  columnConfigStore = [];

  renderHeader(h, params) {
    return (
      <span
        style="cursor:pointer"
        onClick={() => {
          this.showEditModal(null); // 合并编辑:表体添加事件
        }}
      >
        列标题
        <i class="el-icon-add" style="margin-left:10px;color:green" />
      </span>
    );
  }

  saveConfig() {
    this.isFormValid("editForm", isValid => {
      if (isValid) {
        const code = this.actualLayoutCode || this.layoutCode;
        const name = this.actualLayoutName || this.layoutName;
        this.columnModel.cModuleCode = code;
        this.columnModel.cModuleName = this.isCustom ? code : name;

        this.$http
          .post("Base/Module/SaveColumnConfig", {
            columnModel: this.columnModel
          })
          .then(res => {
            if (res.data.status === 0) {
              if (this.isCustom) {
                this.loadColumnModuleCode();
              }
              this.layoutTable.load({
                cModuleCode: code,
                iShow: this.showVisibleOnly ? 1 : 0
              });
            } else if (res.data.status === 1) {
              this.$message.error(`保存失败:${res.data.msg}`);
            } else {
              this.$message.error(`保存失败:未知异常`);
            }
            this.showEdit = false;
          })
          .catch(err => {
            this.$message.error(`保存失败:${err}`);
          });
      }
    });
  }

  deleteConfig(ID) {
    const code = this.actualLayoutCode || this.layoutCode;
    this.$http
      .post("Base/Module/DeleteColumnConfig", { ID: ID })
      .then(res => {
        if (res.data.status === 0) {
          this.loadColumnModuleCode();
          this.layoutTable.load({
            cModuleCode: code,
            iShow: this.showVisibleOnly ? 1 : 0
          });
        } else if (res.data.status === 1) {
          this.$message.error(`删除失败:${res.data.msg}`);
        } else {
          this.$message.error(`删除失败:未知异常`);
        }
      })
      .catch(err => {
        this.$message.error(`删除失败:${err}`);
      });
  }

  initData() {
    const code = this.actualLayoutCode || this.layoutCode;
    const name = this.actualLayoutName || this.layoutName;
    if (!code || !name) {
      this.$message.warning("未定义模块编号,无法快捷初始化数据.");
      return;
    }
    this.loadAppTable();
    this.showInitModal = true;
  }

  onShowVisibleChange(value) {
    this.layoutTable.load({
      cModuleCode: this.actualLayoutCode,
      iShow: value ? 1 : 0
    });
  }

  loadColumnModuleCode() {
    this.$http.get("Base/Module/GetCustomColumnModuleCode").then(res => {
      this.columnConfigStore.splice(0);
      this.columnConfigStore.push(...res.data);
    });
  }

  loadAppTable() {
    this.$http.get("Base/Module/GetAppTable").then(res => {
      this.initDataStore.splice(0);
      this.initDataStore.push(...res.data);
    });
  }

  onDbClick(data) {
    this.showEditModal(data);
  }

  onCustomChagne(value) {
    this.actualLayoutName = value;
    this.layoutTable.load({
      cModuleCode: value,
      iShow: this.showVisibleOnly ? 1 : 0
    });
  }

  showEditModal(data) {
    const code = this.actualLayoutCode || this.layoutCode;
    const name = this.actualLayoutName || this.layoutName;
    this.columnModel.ID = null;
    if (!code || !name) {
      this.$message.warning("未定义模块编号,无法添加明细.");
      return;
    }
    this.resetForm("editForm");
    if (data) {
      this.loadForm(this.columnModel, data);
    }
    this.showEdit = true;
  }

  onDrop(e) {
    this.$http
      .post("Base/Module/SortLayoutConfig", {
        current: e.current,
        target: e.target,
        type: e.type
      })
      .then(res => {});
  }

  addCustomConfig() {
    this.showCustomConfig = true;
  }

  saveCustomValue() {
    this.actualLayoutName = this.actualLayoutCode;
    this.columnConfigStore.push({
      value: this.actualLayoutName,
      label: this.actualLayoutName
    });
    this.actualLayoutCode = this.actualLayoutName;
    this.layoutTable.load({
      cModuleCode: this.actualLayoutCode,
      iShow: this.showVisibleOnly ? 1 : 0
    });
    this.showCustomConfig = false;
  }

  cancelValue() {
    this.showCustomConfig = false;
  }

  doInitData() {
    const code = this.actualLayoutCode || this.layoutCode;
    const name = this.actualLayoutName || this.layoutName;
    this.$http
      .post("Base/Module/InitData", {
        code: code,
        name: name,
        table: this.initSelectTable
      })
      .then(res => {
        if (res.data.status === 0) {
          this.layoutTable.load({
            cModuleCode: code,
            iShow: this.showVisibleOnly ? 1 : 0
          });
        } else if (res.data.status === 1) {
          this.$message.error(`初始化失败:${res.data.msg}`);
        } else {
          this.$message.error(`初始化失败:未知异常`);
        }
        this.showInitModal = false;
      })
      .catch(err => {
        this.$message.error(`初始化失败:${err}`);
      });
  }

  // 通过列渲染方式实现之定义列
  renderOperation(props) {
    return (
      <div style="display:inline;">
        <el-tooltip content="删除" hide-after={1000} placement="bottom">
          <el-button
            style="padding:7px;"
            type="danger"
            icon="el-icon-delete"
            onClick={() => {
              this.deleteConfig(props.row.ID);
            }}
          />
        </el-tooltip>
      </div>
    );
  }
}
